module.exports = __webpack_public_path__ + "img/bkash-icon-logo.39108ec4.svg";